"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
var _personAdded = _interopRequireDefault(require("@atlaskit/icon/core/person-added"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const PersonWithTickIcon = props => /*#__PURE__*/_react.default.createElement(_base.IconFacade, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.94 12a6.48 6.48 0 0 0-1.81 4.5c0 1.626.597 3.112 1.583 4.252C8.161 21.448 3 20.68 3 18.446V14c0-1.105.902-2 2.009-2zM9 11a4 4 0 1 1 0-8 4 4 0 0 1 0 8m7.5 11a5.5 5.5 0 1 1 0-11 5.5 5.5 0 0 1 0 11m-1.892-5.808a.825.825 0 0 0-1.166 1.166l1.65 1.65a.825.825 0 0 0 1.166 0l3.3-3.3a.825.825 0 0 0-1.166-1.166l-2.717 2.716z"/></svg>`
}, props, {
  newIcon: _personAdded.default
}));
PersonWithTickIcon.displayName = 'PersonWithTickIcon';
var _default = exports.default = PersonWithTickIcon;